export const REQUEST_CREDITOR_MAILING = 'REQUEST_CREDITOR_MAILING';
export const RECEIVE_CREDITOR_MAILING = 'RECEIVE_CREDITOR_MAILING';
export const SERVICE_ERROR = 'SERVICE_ERROR';
export const RESET_SERVICE_ERROR = 'RESET_SERVICE_ERROR';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/creditorMailingTypes.js